
import { Localization } from "@viamap/viamap2-common";
import { MapInfo, PictureLayoutType, PictureSize, PopupLayout } from '../common/managers/Types';
import { SelectWithOptionsV2 } from './ComponentUtils';
import { ADModalBody, ADModalFooter, AdvancedDragModal } from 'src/componentsUtils/AdvancedDragModal';
import { GlassButton } from './GlassButtons';
import { GlassInputControl, GlassInputGroup, GlassTextInputTransformer } from './GlassInput';
import { useContext, useState } from "react";
import { createPortal } from "react-dom";
import { actionUpdateMapInfo, MapitStateContext } from "src/states/MapitState";
import { ManagedWindow } from "src/WindowManager/WindowState";
// import { SketchPicker } from 'react-color';

type Props = {
    managedWindow: ManagedWindow;
    // mapInfo: MapInfo;
    // callbackOnMapStyling: (mapInfo:MapInfo)=>void;
    onClose: () => void;
};

export type OptionType = {
    [value: string]: string;
};

export function MapStyling(props: Props) {
    const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);

    const [mapInfo, setMapInfo] = useState<MapInfo>(mapitState.mapInfo)

    function onMapStyling(mapInfo: MapInfo) {
        mapitStateDispatch(actionUpdateMapInfo(mapInfo));
    }


    function handleClose(e: any) { e.preventDefault(); props.onClose(); }

    function nameOnBlur(evt: any) {
        evt.preventDefault();
        let newMapInfo = { ...mapInfo, mapTitle: evt.target.value }
        setMapInfo(newMapInfo)
        onMapStyling(newMapInfo);
    }

    function pictureLayoutTypeOnChange(evt: any) {
        let newMapInfo = { ...mapInfo, popUpPictureLayout: evt.target.value || PictureLayoutType.Center };
        setMapInfo(newMapInfo)
        onMapStyling(newMapInfo);
    }

    function pictureSizeOnChange(evt: any) {
        let newMapInfo = { ...mapInfo, popUpPictureSize: evt.target.value || PictureSize.Medium };
        setMapInfo(newMapInfo)
        onMapStyling(newMapInfo);
    }

    function popupLayoutOnChange(evt: any) {
        let newMapInfo = { ...mapInfo, popUpLayout: evt.target.value || PopupLayout.ShowAll };
        setMapInfo(newMapInfo)
        onMapStyling(newMapInfo);
    }

    function generateSelectionList(list: string[]): { label: string, value: string }[] {
        return list.map((item) => {
            return { value: item, label: Localization.getText(item) };
        });
    }

    // generatePictureLayoutList(list:any[]):any[] {
    //     function getLabel(val:PictureLayoutType) { 
    //         return Localization.getText(val);
    //     }

    //     return list.map((item) => {
    //         return {value: item, label: getLabel(item)};
    //     });

    //     // return [ 
    //     //     {value: PictureLayoutType.Center, label: getLabel(PictureLayoutType.Center)},
    //     //     {value: PictureLayoutType.Left, label: getLabel(PictureLayoutType.Left)},
    //     //     {value: PictureLayoutType.Right, label: getLabel(PictureLayoutType.Right)}
    //     // ];
    // }

    // generatePictureSizeList(list:any[]):any[] {
    //     function getLabel(val:PictureSize) { 
    //         return Localization.getText(val);
    //     }

    //     return list.map((item) => {
    //         return {value: item, label: getLabel(item)};
    //     });

    //     return [ 
    //         {value: PictureSize.Small, label: getLabel(PictureSize.Small)},
    //         {value: PictureSize.Medium, label: getLabel(PictureSize.Medium)},
    //         {value: PictureSize.Large, label: getLabel(PictureSize.Large)}
    //     ];
    // }



    // const keys = Object.keys(PictureLayoutType); // .filter(k => typeof PictureLayoutType[k as any] === "number"); // ["A", "B"]
    //    let list = this.generatePictureLayoutList(keys);
    let selectPictureLayoutType = SelectWithOptionsV2(
        generateSelectionList(Object.keys(PictureLayoutType)),
        "PictureLayoutType",
        (evt) => pictureLayoutTypeOnChange(evt),
        Localization.getText("Picture Layout"),
        mapInfo && mapInfo.popUpPictureLayout ? mapInfo.popUpPictureLayout.toString() : ""
    );
    let RenderPictureLayoutType = (
        <GlassTextInputTransformer label={Localization.getText("Picture Layout")}>
            <GlassInputControl>
                {selectPictureLayoutType}
            </GlassInputControl>
        </GlassTextInputTransformer>
    );

    let selectPopupLayout = SelectWithOptionsV2(
        generateSelectionList(Object.keys(PopupLayout)),
        "PopupLayout",
        (evt) => popupLayoutOnChange(evt),
        Localization.getText("Popup layout"),
        mapInfo && mapInfo.popUpLayout
    );
    let RenderPopupLayout = (
        <GlassTextInputTransformer label={Localization.getText("Popup layout")}>
            <GlassInputControl>
                {selectPopupLayout}
            </GlassInputControl>
        </GlassTextInputTransformer>
    );

    // const keys2 = Object.keys(PictureSize); // .filter(k => typeof PictureSize[k as any] === "number"); // ["A", "B"]
    // let list2 = this.generatePictureSizeList(keys2);
    let selectPictureSize = SelectWithOptionsV2(
        generateSelectionList(Object.keys(PictureSize)),
        "PictureSize",
        (evt) => pictureSizeOnChange(evt),
        Localization.getText("Picture Size"),
        mapInfo && mapInfo.popUpPictureSize ? mapInfo.popUpPictureSize.toString() : ""
    );
    let RenderPictureSize = (
        <GlassTextInputTransformer label={Localization.getText("Picture Size")}>
            <GlassInputControl>
                {selectPictureSize}
            </GlassInputControl>
        </GlassTextInputTransformer>
    );

    let InputMapTitle = (
        <input
            placeholder={Localization.getText("Savemap:defaultFileName")}
            type='text'
            value={(mapInfo && mapInfo.mapTitle) || ""}
            onChange={(evt) => nameOnBlur(evt)}
        />
    );

    let RenderMapTitle = (
        <GlassTextInputTransformer label={
            Localization.getText("Name")
        }>
            <GlassInputControl>
                {InputMapTitle}
            </GlassInputControl>
        </GlassTextInputTransformer>
    );

    return createPortal(
        <AdvancedDragModal
            window={props.managedWindow}
            variant={"NSWhite"}
            PosDefault={{ left: "50%", top: "5%", transform: "translateX(-50%)" }}
            title={Localization.getText("Map Settings")}
        >

            <ADModalBody >
                <GlassInputGroup
                    autoFocus={0}
                    onSubmit={() => { onMapStyling(mapInfo) }}
                    onEscape={(e) => { handleClose(e) }}
                >
                    {RenderMapTitle}
                    {RenderPictureSize}
                    {RenderPictureLayoutType}
                    {RenderPopupLayout}
                    {/* {labelColumn}
                    {checkItem} */}
                </GlassInputGroup>
            </ADModalBody>
            <ADModalFooter>
                <GlassButton
                    onClick={(e) => handleClose(e)}
                >
                    {Localization.getText("Close")}
                </GlassButton>
            </ADModalFooter>
        </AdvancedDragModal>
        , document.getElementById("Mit-MapOverlay") || document.body)
}
